import { RadioactiveCircleIcon } from './RadioactiveCircleIcon';

/**
 * author: Michael Miday
 * id DBCBBE8F-7DFA-4C05-8A2C-8BDE851A0322
 * name radioactive-circle
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/radioactive-circle.svg
 * tags
 * - Science 
 */
export const RadiationCircleIcon = RadioactiveCircleIcon;
export default RadiationCircleIcon